import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, of, switchMap, throwError } from 'rxjs';
import { StateManagementService } from './services/state-management.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const stateManagementService = inject(StateManagementService);
  const isKbEndpoint = req.url.includes('api/v1/kb') || req.url.includes('/api/v1/etc/kbalias') || req.url.includes('/getInstitutionRegistryByKey');
  const isUserValidationRequest = req.url.includes('/users/validate');

  const getToken = () => isKbEndpoint ? stateManagementService.getPlatformToken() : stateManagementService.getJwtToken();
  const withToken = (token: string | null) => token ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }) : req;

  const sentToken = getToken();

  return next(withToken(sentToken)).pipe(
    catchError((error) => {
      if ((error?.status !== 401 && error?.status !== 403) || isUserValidationRequest) {
        return throwError(() => error);
      }

      // Skip validation if another request already renewed the token while this one was in flight.
      const currentToken = getToken();
      const isSessionValid$ = currentToken && currentToken !== sentToken
        ? of(true)
        : stateManagementService.revalidateSession();

      return isSessionValid$.pipe(
        switchMap((isSessionValid) => {
          if (!isSessionValid) {
            stateManagementService.handleTokenExpired();
            return throwError(() => error);
          }
          // Retried once only: a repeat 401/403 for a valid user goes to the caller as a permission error.
          return next(withToken(getToken()));
        }),
      );
    }),
  );
};
